import { createComputed, Show } from "solid-js";
import { RouteSectionProps } from "@solidjs/router";

import Spinner from "@repo/ui/loaders/Spinner";
import Env from "@repo/utils-client/Env";

import { useUser } from "~/state/features/user";

export default function AuthenticatedLayout({
  children,
}: D<RouteSectionProps>) {
  const [user] = useUser();

  createComputed(() => {
    if (user.authenticated() === false)
      window.location.replace(
        `${Env.resolveUrl(import.meta.env.WEB_ORIGIN)}/login?origin=${encodeURIComponent(window.location.href)}`
      );
  });

  return (
    <Show when={user.authenticated()} fallback={<Spinner.Common />}>
      {children}
    </Show>
  );
}
